// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ApproverUserDetailFragmentDoc } from '../../../../../../fragments/circularFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReviewStepChangeEventQueryVariables = Types.Exact<{
  changeEventId: Types.Scalars['ID']['input'];
}>;


export type ReviewStepChangeEventQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', id: string, budgetImpactInCents: number, totalPriceInCents: number, type: { __typename?: 'ChangeEventTypeDetail', code: Types.ChangeEventType }, workflow?: { __typename?: 'ChangeEventWorkflowDetail', code: Types.ChangeEventWorkflow } | null | undefined, project:
      | { __typename?: 'StandaloneProject', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      | { __typename?: 'Region', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      | { __typename?: 'Market', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      | { __typename?: 'Community', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      | { __typename?: 'Subdivision', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      | { __typename?: 'Lot', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      | { __typename?: 'Structure', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      | { __typename?: 'Unit', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    , lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, totalCostInCents: number, typeDetail: { __typename?: 'ChangeEventLineItemTypeDetail', code: Types.ChangeEventLineItemType, name: string } }>, impactedCommitments: Array<
      | { __typename?: 'Commitment', id: string }
      | { __typename?: 'CommitmentChangeOrder', id: string }
    >, predictedApprovers: Array<
      | { __typename?: 'Client', id: string, name: string }
      | { __typename?: 'InternalUser', id: string, avatar: string, name: string, projectRoleDetail?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined }
      | { __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }
    > } };

export type ReviewStep_ChangeEventFragment = { __typename?: 'ChangeEvent', id: string, budgetImpactInCents: number, totalPriceInCents: number, type: { __typename?: 'ChangeEventTypeDetail', code: Types.ChangeEventType }, workflow?: { __typename?: 'ChangeEventWorkflowDetail', code: Types.ChangeEventWorkflow } | null | undefined, project:
    | { __typename?: 'StandaloneProject', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Region', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Market', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Community', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Subdivision', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Lot', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Structure', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Unit', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
  , lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, totalCostInCents: number, typeDetail: { __typename?: 'ChangeEventLineItemTypeDetail', code: Types.ChangeEventLineItemType, name: string } }>, impactedCommitments: Array<
    | { __typename?: 'Commitment', id: string }
    | { __typename?: 'CommitmentChangeOrder', id: string }
  >, predictedApprovers: Array<
    | { __typename?: 'Client', id: string, name: string }
    | { __typename?: 'InternalUser', id: string, avatar: string, name: string, projectRoleDetail?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined }
    | { __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }
  > };

export type ReviewStep_Approver_Client_Fragment = { __typename?: 'Client', id: string, name: string };

export type ReviewStep_Approver_InternalUser_Fragment = { __typename?: 'InternalUser', id: string, avatar: string, name: string, projectRoleDetail?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined };

export type ReviewStep_Approver_TradePartnerUser_Fragment = { __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } };

export type ReviewStep_ApproverFragment =
  | ReviewStep_Approver_Client_Fragment
  | ReviewStep_Approver_InternalUser_Fragment
  | ReviewStep_Approver_TradePartnerUser_Fragment
;

export const ReviewStep_ApproverFragmentDoc = gql`
    fragment ReviewStep_Approver on ApproverUser {
  ...ApproverUserDetail
  ... on InternalUser {
    id
    projectRoleDetail {
      code
      name
    }
  }
}
    ${ApproverUserDetailFragmentDoc}`;
export const ReviewStep_ChangeEventFragmentDoc = gql`
    fragment ReviewStep_ChangeEvent on ChangeEvent {
  id
  budgetImpactInCents
  totalPriceInCents
  type {
    code
  }
  workflow {
    code
  }
  project {
    id
    lotType {
      code
      clientNoun
    }
  }
  lineItems {
    id
    totalCostInCents
    typeDetail {
      code
      name
    }
  }
  impactedCommitments {
    id
  }
  predictedApprovers {
    ...ReviewStep_Approver
  }
}
    ${ReviewStep_ApproverFragmentDoc}`;
export const ReviewStepChangeEventDocument = gql`
    query ReviewStepChangeEvent($changeEventId: ID!) {
  changeEvent(id: $changeEventId) {
    ...ReviewStep_ChangeEvent
  }
}
    ${ReviewStep_ChangeEventFragmentDoc}`;

/**
 * __useReviewStepChangeEventQuery__
 *
 * To run a query within a React component, call `useReviewStepChangeEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewStepChangeEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewStepChangeEventQuery({
 *   variables: {
 *      changeEventId: // value for 'changeEventId'
 *   },
 * });
 */
export function useReviewStepChangeEventQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewStepChangeEventQuery, ReviewStepChangeEventQueryVariables> & ({ variables: ReviewStepChangeEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewStepChangeEventQuery, ReviewStepChangeEventQueryVariables>(ReviewStepChangeEventDocument, options);
      }
export function useReviewStepChangeEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewStepChangeEventQuery, ReviewStepChangeEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewStepChangeEventQuery, ReviewStepChangeEventQueryVariables>(ReviewStepChangeEventDocument, options);
        }
// @ts-ignore
export function useReviewStepChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReviewStepChangeEventQuery, ReviewStepChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewStepChangeEventQuery, ReviewStepChangeEventQueryVariables>;
export function useReviewStepChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewStepChangeEventQuery, ReviewStepChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewStepChangeEventQuery | undefined, ReviewStepChangeEventQueryVariables>;
export function useReviewStepChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewStepChangeEventQuery, ReviewStepChangeEventQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewStepChangeEventQuery, ReviewStepChangeEventQueryVariables>(ReviewStepChangeEventDocument, options);
        }
export type ReviewStepChangeEventQueryHookResult = ReturnType<typeof useReviewStepChangeEventQuery>;
export type ReviewStepChangeEventLazyQueryHookResult = ReturnType<typeof useReviewStepChangeEventLazyQuery>;
export type ReviewStepChangeEventSuspenseQueryHookResult = ReturnType<typeof useReviewStepChangeEventSuspenseQuery>;
export type ReviewStepChangeEventQueryResult = ApolloReactCommon.QueryResult<ReviewStepChangeEventQuery, ReviewStepChangeEventQueryVariables>;